import Modal from "@material-ui/core/Modal";

import { DialogContentText, makeStyles } from "@material-ui/core";
import React from "react";
import CustomModal from "./custom-modal";

export default function ConfirmationModal(props) {
    const useStyles = makeStyles(() => ({
        confirmationBtn: {
            backgroundColor: '#b9251c',
            color: '#fff',
            border: '#b9251c'
        },
        '.MuiButton-contained:hover': {
            backgroundColor: '#b9251c !important',
        }
      }));

    const classes = useStyles();

    return (
        <>
              <CustomModal
                size="medium"
                title={props.title}
                showCloseIcon
                submitBtnText={props.confirmationBtnText}
                loading = {props.loading}
                showModal={props.open}
                onCloseModal={() => props.onClose()}
                splitActions = {false}
                onSubmit={props.onConfirm}
            >{props.message}
            </CustomModal>
        </>
    )

}